module.exports = {
  getMessage: (field, args) => 'Télemovel deve começar com o numero ' + args,
  validate: (value, args) => {
    var res = value[0]
    if (res === args[0]) {
      return true
    } else {
      return false
    }
  }
}
